import * as React from "react";

import { cn } from "@/shadcn/lib/utils";

export type DividerProps = React.HTMLAttributes<HTMLDivElement> & {
  readonly label?: React.ReactNode;
};

export const Divider = React.forwardRef<HTMLDivElement, DividerProps>(({ label }, ref) => {
  if (!label) {
    return (
      <div className={cn("my-2 w-full py-2")} ref={ref}>
        <hr className="w-full border-neutral-200" />
      </div>
    );
  }

  return (
    <div className={cn("flex w-full items-center gap-3 py-2")} ref={ref}>
      <hr className="flex-1 border-neutral-200" />
      <span className="block type-subtitle text-foreground">{label.toString()}</span>
      <hr className="flex-1 border-neutral-200" />
    </div>
  );
});

Divider.displayName = "Divider";
